import { render, staticRenderFns } from "./nwp-alaef.vue?vue&type=template&id=18805574&scoped=true&"
import script from "./nwp-alaef.vue?vue&type=script&lang=js&"
export * from "./nwp-alaef.vue?vue&type=script&lang=js&"
import style0 from "./nwp-alaef.vue?vue&type=style&index=0&id=18805574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18805574",
  null
  
)

export default component.exports